import { styled } from "@mui/material/styles";

export const SvgWrapper = styled("div")<{
  color?: string;
  size?: number | string;
  contentWithFullSize?: boolean;
}>(({ color, size, contentWithFullSize }) => {
  const contentFullsize = contentWithFullSize
    ? {
        "& > svg": {
          width: size,
          height: size,
        },
      }
    : undefined;

  return {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    color,
    width: size,
    height: size,
    ...contentFullsize,
  };
});
